import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultRhqInfo } from '../interfaces/RhqInfo'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface CD01RhqInfoGetProps {
  execRhqInfoGet: (rhq: string) => Promise<ResultRhqInfo>
  loading: loadStatus
}
// CD01 RHQ情報取得API呼出
export const useCD01RhqInfoGet = (): CD01RhqInfoGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildUrl } = useApiUrl()
  const execRhqInfoGet = async (rhq: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.get(`${buildUrl(apiUrl.rhqInfoPath)}${rhq}`, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        return { success: true, info: response.data }
      }
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } finally {
      setLoading(loadStatus.LOADED)
    }
  }

  return { execRhqInfoGet, loading }
}
